import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { ContragentService } from '@zaoblako/web/core/services/client/contragent.service';
import { ContragentAutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/contragent-auto-complete/contragent-auto-complete.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-contragent-deleting-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, SpinnerComponent, ContragentAutoCompleteComponent],
  templateUrl: './contragent-deleting-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContragentDeletingModalComponent implements OnInit {
  public contragents: ContragentFindInterface[] = [];
  public contragent: ContragentFindInterface;

  public loading = false;
  public previousContragentId: number;

  public constructor(
    private readonly contragentService: ContragentService,
    private readonly config: DynamicDialogConfig,
    private readonly cdRef: ChangeDetectorRef,
    public readonly ref: DynamicDialogRef
  ) {
    this.previousContragentId = config.data?.previousContragentId;
  }

  public ngOnInit() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.contragentService.search().subscribe({
      next: (contragents) => {
        this.contragents = contragents.filter((contragent) => this.previousContragentId !== contragent.id);
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
